import { Tabs } from "@mantine/core";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import PlusIcon from "../components/common/Icons/PlusIcon";
import TagSettingsTable from "../components/Settings/Tags/TagSettingsTable";
import { TagKind } from "../api/tagApi";

const TABS: {
  value: TagKind;
  label: string;
  button: string;
  title: string;
}[] = [
  { value: "role", label: "Roller", button: "Yeni Rol", title: "Rol Ayarları" },
  {
    value: "skill",
    label: "Yetenekler",
    button: "Yeni Yetenek",
    title: "Yetenek Ayarları",
  },
];

/**
 * Rol ve yetenek ayarlarının tek sayfası.
 * Eski RoleSettings + SkillSettings sayfalarının yerine geçer.
 * (Üçüncü sekme "Etiketler" 24 Ağu'da kaldırıldı — yetenekle birebir aynıydı.)
 *
 * ⚠ "ETİKET" KELİMESİ ARAYÜZDE GEÇMEZ. Depolamada rol ve yetenek tek
 * koleksiyonda `kind` ile ayrışıyor, ama bu bir uygulama detayı: kullanıcıya
 * öğretilecek üçüncü bir kavram değil. Birleştirmenin amacı sadeleştirmekti;
 * "etiket" diye ayrı bir ad kullanmak tam tersini yapıp ortaya üçüncü bir şey
 * çıkarıyordu. Başlık ve menü bu yüzden doğrudan "Rol" / "Yetenek" der.
 */
const TagSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get("kind");
  const kind: TagKind = TABS.some((t) => t.value === raw)
    ? (raw as TagKind)
    : "role";
  const active = TABS.find((t) => t.value === kind)!;

  return (
    <Container>
      <PageHeader
        pageTitle={active.title}
        subText="Rol ve yetenekler tek yerden yönetilir."
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText={active.button}
        buttonOnClick={() => navigate(`${location.pathname}/new?kind=${kind}`)}
      />

      <Tabs
        value={kind}
        onChange={(value) => value && setSearchParams({ kind: value })}
        color="#5C26FF"
        keepMounted={false}
      >
        <Tabs.List mb={20}>
          {TABS.map((tab) => (
            <Tabs.Tab key={tab.value} value={tab.value}>
              {tab.label}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {TABS.map((tab) => (
          <Tabs.Panel key={tab.value} value={tab.value}>
            <TagSettingsTable kind={tab.value} />
          </Tabs.Panel>
        ))}
      </Tabs>
    </Container>
  );
};

export default TagSettings;
